export default __webpack_public_path__ + "static/media/kid 2.d0ce3469.png";